import { render, staticRenderFns } from "./SelectOrganisation.vue?vue&type=template&id=ffb64164"
import script from "./SelectOrganisation.vue?vue&type=script&lang=js"
export * from "./SelectOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports